import { ContentReplaceStatus } from 'app/library/scorm/enums/content-replace-status.enum';
import { IModuleQuery } from '../interfaces/module.query.interface';
import { Module } from './module.model';

export class ELearningModule extends Module {
    courseImportJobId: string;
    courseId: string;
    contentUpdatedAt: string | null;
    contentReplaceStatus: ContentReplaceStatus | null;

    constructor(moduleQuery?: IModuleQuery) {
        super(moduleQuery);

        this._type = 'e_learning';

        if (moduleQuery) {
            this.courseImportJobId = moduleQuery.course_import_job_id;
            this.courseId = moduleQuery.course_id;
            this.contentUpdatedAt = moduleQuery.content_updated_at ?? null;
            this.contentReplaceStatus = (moduleQuery.content_replace_status as ContentReplaceStatus) || null;
        }
    }
}
